<a href="https://www.linkedin.com/company/pin-up-partners" class="social-links__item">
  <cab-icon class="social__link" iconName="linkedin" [size]="size" />
</a>
<a href="https://www.instagram.com/pinupaff" class="social-links__item">
  <cab-icon class="social__link" iconName="instagram" [size]="size" />
</a>
<a href="https://t.me/pinupregmanager" class="social-links__item">
  <cab-icon class="social__link" iconName="telegram" [size]="size" />
</a>
